import { MaskedLine } from "@/components/Reveal";

export default function MarketplaceIntro() {
  return (
    <section data-testid="marketplace-intro" className="border-t border-[#E5E5DE] pt-14 md:pt-20 pb-20">
      <div className="max-w-[1100px] mx-auto px-6 text-center">
        <MaskedLine delay={0.05}>
          <p className="text-[11px] font-semibold tracking-[0.35em] uppercase text-[#4C8C1E]">
            B2B Marketplace — Coming Soon
          </p>
        </MaskedLine>
        <h2 data-testid="marketplace-intro-heading" className="font-serif text-5xl md:text-7xl leading-[1.05] mt-7 text-[#16180F]">
          <MaskedLine delay={0.2}>Where buyers meet</MaskedLine>
          <MaskedLine delay={0.35}>suppliers — and</MaskedLine>
          <MaskedLine delay={0.5}>
            <span className="italic">performance follows.</span>
          </MaskedLine>
        </h2>
        <MaskedLine delay={0.65} className="max-w-2xl mx-auto">
          <p className="mt-8 text-base md:text-lg font-light text-[#55564A] leading-relaxed">
            eProcure Inc. is a consulting practice helping organizations improve business
            performance — and a web-based marketplace where buyers list requirements and
            access a living database of suppliers.
          </p>
        </MaskedLine>
      </div>
    </section>
  );
}
